import i18n from '@/i18n/index';

export function verifyAddress(address) {
  return (
    i18n.locale !== 'en' && (
      address === ''
      || address.length < 6
      || (!address.includes(i18n.t('store.county')) && !address.includes(i18n.t('store.city')))
    )
  );
}

export default verifyAddress;
